<template>
    <div>
        Help
    </div>
</template>

<script setup>

</script>

<style lang="scss"
       scoped></style>
